import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback } from "react";
import { DateFilterTypeSelect } from "~/components/Filters/DateFilter/DateFilterTypeSelect";
import { DateRangeInput } from "../../../../../../packages/component/editable-date";
export const DateFilter = /*#__PURE__*/ memo((param)=>{
    let { startDate, endDate, selectedType, onStartDateChange, onEndDateChange, onTypeChange } = param;
    const onDateFilterTypeChange = useCallback((selectedType)=>{
        onStartDateChange();
        onEndDateChange();
        onTypeChange(selectedType);
    }, [
        onEndDateChange,
        onStartDateChange,
        onTypeChange
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsx(DateFilterTypeSelect, {
                selectedType: selectedType,
                onTypeChange: onDateFilterTypeChange
            }),
            selectedType === "custom-range" ? /*#__PURE__*/ _jsx(DateRangeInput, {
                size: "large",
                startDate: startDate,
                endDate: endDate,
                onStartDateChange: onStartDateChange,
                onEndDateChange: onEndDateChange
            }) : null
        ]
    });
});
DateFilter.displayName = "DateFilter";
